module.exports = __webpack_public_path__ + "img/logo_alpha.f97b9e1b.png";